import styled from '@emotion/styled';
import React from 'react';

import { LENS_CDN } from '../../constants/routes';

const sizeToPx = {
  small: '40px',
  medium: '80px',
};

const LogoLoaderWrapper = styled.span<LogoLoaderProps>`
  animation: ${props => props.animation};
  background-image: url(${LENS_CDN}/${props => props.brand}-loader.svg);
  background-size: cover;
  background-position: left center;
  display: block;
  height: ${props => sizeToPx[props.size]};
  width: ${props => sizeToPx[props.size]};

  @keyframes spin {
    100% {
      background-position: right center;
    }
  }
`;

const LogoLoader = ({
  animation = 'spin 2s infinite steps(49) forwards',
  brand = 'loom',
  size = 'medium',
}: LogoLoaderProps & React.ComponentProps<typeof LogoLoaderWrapper>) => {
  return <LogoLoaderWrapper animation={animation} brand={brand} size={size} />;
};

type LogoLoaderProps = {
  animation?: string;
  brand?: 'loom' | 'ai';
  size?: 'small' | 'medium';
};

export default LogoLoader;
